import { createStore } from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Loading } from 'quasar'
import dateFormat from 'dateformat'
import countries from './countries'

const weekAgo = new Date();
weekAgo.setDate(weekAgo.getDate() - 7);

const Store = createStore({
  state: {
    user: null,
    amount: 0,
    period: 0,
    screenWidth: window.innerWidth,
    menuOpen: false,
    metaTitle: '',
    metaDescription: '',
    countries,
    campaigns: [],
    campaign: null,
    returnRoute: null,
    userDayAggregations: [],
    frontendUrl: process.env.FRONTEND_URL,
    backendUrl: process.env.BACKEND_URL,
    dateFrom: dateFormat(weekAgo, 'UTC:yyyy-mm-dd'),
    dateTo: dateFormat(Date.now(), 'UTC:yyyy-mm-dd'),
    dateCompareFrom: null,
    dateCompareTo: null,
    userConversions: [],
    notifications: [],
    selectedCampaigns: [],
    selectedUser: null,
    selectedSubPublisher: null,
    clicksByCampaign: 0
  },
  getters,
  actions,
  mutations,
  strict: process.env.DEBUGGING
});

Store.dispatch('getAuthenticatedUser');
Store.dispatch('fetchCampaigns');

window.addEventListener('resize', () =>
  Store.commit('setScreenWidth', window.innerWidth)
);

document.addEventListener('rendered', () => {
  Loading.hide();
})

export default Store;
